import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

import styles from '../styles/header.scss';
import APP_ROUTES from '../../../constants/app-routes';
import LocaleSelectorConnector from '../../../containers/locale-selector-connector';
import KWalletActivateModal from '../kwallet-activation-modal';

const pageWallet = 'kwallet';

class UserMobilMenu extends Component {
    constructor(props) {
        super(props);
        this.container = React.createRef();
        this.state = {
            showUserMenu: false,
            showActivateKWallet: false,
        };

        this.toggleUserMenu = this.toggleUserMenu.bind(this);
    }

    onLogout() {
        this.toggleUserMenu();
        this.props.logout();
    }

    getResult() {
        let result;
        const { user } = this.props;

        if (user && user.id) {
            result = (
                <li className="dropdown config hidden-md hidden-lg pull-right" style={{ marginLeft: '15px' }}>
                    <a className={`dropdown-toggle line-double ${styles.lineDouble} ${styles.avatar_mobile}`} onClick={this.toggleUserMenu}>
                        <span className="text">
                            <i className="pe-7f-user pe-lg pe-va" />
                            {/* <span className={styles.hello}>
                                <FormattedMessage id="hello" defaultMessage="Hello!" />
                            </span>
                            <span style={{ color: '#d3af71' }}>{user.email.split('@')[0]}</span> */}
                        </span>
                        {/* <i
                            className={`pe-7s-angle-down pe-1x pe-va font-weight-bold ${styles.angleDown}`}
                            style={{ display: this.state.showUserMenu ? 'none' : 'inline-block' }}
                        />
                        <i className={`pe-7s-angle-up pe-1x pe-va font-weight-bold ${styles.angleUp}`} style={{ display: this.state.showUserMenu ? 'inline-block' : 'none' }} /> */}
                    </a>
                    <ul className={`dropdown-menu ${styles.userMenuDropdowns}`} style={{ display: this.state.showUserMenu ? 'block' : 'none' }}>
                        <li className={styles.mobileWelcomeLine}>
                            <div>
                                <span className={styles.hello}>
                                    <FormattedMessage id="hello" defaultMessage="Hello!" />
                                </span>
                                <span>{user.email.split('@')[0]}</span>
                            </div>
                        </li>
                        <li onClick={() => this.toggleUserMenu()}>
                            <Link to={APP_ROUTES.orders}>
                                <span className={`pe-7s pe-7s-user ${styles.userMenuIcon}`} />
                                <FormattedMessage id="my-orders" defaultMessage="My Orders" />
                            </Link>
                        </li>
                        {process.env.REACT_APP_KWALLET_ENABLED === 'true' && (
                            <li>
                                <a onClick={() => this.checkForActiveWallet(pageWallet)}>
                                    <span className={`pe-7s pe-7s-user ${styles.userMenuIcon}`} />
                                    <FormattedMessage id="manage-k-wallet" defaultMessage="Administrar K-Wallet" />
                                </a>
                            </li>
                        )}
                        <li>
                            <a onClick={() => this.onLogout()}>
                                <FormattedMessage id="logout" defaultMessage="Logout" />
                            </a>
                        </li>
                    </ul>
                </li>
            );
        } else {
            result = process.env.REACT_APP_DISABLE_AUTH !== 'true' && (
                <Link to={APP_ROUTES.signin} className={`link-xs hidden-md hidden-lg pull-right ${styles.signin}`}>
                    <FormattedMessage id="signin" defaultMessage="Signin" />
                    <i className="pe-7f-user pe-lg pe-va" />
                </Link>
            );
        }
        return result;
    }

    checkForActiveWallet = async (wallet) => {
        const result = await this.props.isWalletActive(this.props.access_token, pageWallet);
        if (result) {
            window.location.assign(APP_ROUTES.manageKWallet);
        } else {
            this.setState({
                showActivateKWallet: true,
            });
        }
    }

    handleKWalletActivateModal = async (result) => {
        if (result) {
            const activate = await this.props.activateWallet(this.props.access_token, pageWallet);
            this.setState({
                showActivateKWallet: false,
            });
            if (activate) {
                window.location.assign(APP_ROUTES.manageKWallet);
            }
        } else {
            this.setState({
                showActivateKWallet: false,
            });
        }
    };

    handleClickOutside = (event) => {
        if (
            this.container.current && !this.container.current.contains(event.target)
        ) {
            document.removeEventListener('mousedown', this.handleClickOutside);
            this.setState({
                showUserMenu: false,
            });
        }
    };

    toggleUserMenu() {
        this.setState((prevState) => ({ showUserMenu: !prevState.showUserMenu }), () => {
            if (this.state.showUserMenu) {
                document.addEventListener('mousedown', this.handleClickOutside);
            } else {
                document.removeEventListener('mousedown', this.handleClickOutside);
            }
        });
    }

    render() {
        const { user } = this.props;

        return (
            <div className={`nav navbar-nav navbar-right hidden-md hidden-lg ${styles.navbarNav} ${styles.icons}`} ref={this.container}>
                {this.getResult()}
                <div className="row pull-right" style={{ marginRight: '3px' }}>
                    <LocaleSelectorConnector />
                </div>
                <div style={{ clear: 'both' }} />
                <KWalletActivateModal isOpen={this.state.showActivateKWallet} handleClose={this.handleKWalletActivateModal} />
            </div>
        );
    }
}

export default UserMobilMenu;



/** WEBPACK FOOTER **
 ** ./src/components/shared/header/user-mobile-menu.jsx
 **/